// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FolderOpenIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FolderOpenIcon" ref={forwardedRef} {...props}>
      <path d="M3.996 3.998a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6.495a1 1 0 0 0-1-1h-4.005l-1.728-1.297a1 1 0 0 0-.6-.2zm.5 2.997h11v8.503h-11z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FolderOpenIcon = /* @__PURE__ */ Object.assign(
  FolderOpenIconComponent,
  { displayName: 'FolderOpenIcon' },
);
